import { render } from "./ParsingConfigField.vue?vue&type=template&id=34c0894c&scoped=true"
import script from "./ParsingConfigField.vue?vue&type=script&lang=js"
export * from "./ParsingConfigField.vue?vue&type=script&lang=js"

import "./ParsingConfigField.vue?vue&type=style&index=0&id=34c0894c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c0894c"]])

export default __exports__